module.exports = __webpack_public_path__ + "static/dogs-6ea6551ba12129a9abd8e2c102f3a4d0.png";